import { DataProxy } from '@apollo/client';
import { JobQueryType, JobSearchType, JobSearchByQueryType } from './types';

const updateCollection: (
  jobSearchByQuery: JobSearchType | undefined,
  jobId: string | undefined,
  bookmarked: boolean
) => void = (jobSearchByQuery, jobId, bookmarked) =>
  jobSearchByQuery?.collection.map((item: JobQueryType) => {
    if (item.jobDetail.id === jobId) {
      return {
        ...item,
        jobDetail: {
          ...item.jobDetail,
          userInteractions: {
            ...item.jobDetail.userInteractions,
            bookmark: {
              state: updateBookmarkStateOnCache(bookmarked),
              __typename: 'JobBookmark',
            },
          },
        },
      };
    }
    return {
      ...item,
    };
  });

const updateCache = ({
  cache,
  query,
  variables,
  bookmarked,
  jobId,
  data,
}: {
  cache: DataProxy;
  query: any;
  variables: any;
  bookmarked: boolean;
  jobId: string;
  data: JobSearchByQueryType;
}) => {
  if (!data?.jobSearchByQuery) {
    return;
  }

  const queryData: JobSearchByQueryType | null = cache.readQuery({
    query,
    variables,
  });
  if (!queryData) {
    return;
  }
  const { jobSearchByQuery } = queryData;

  cache.writeQuery({
    query,
    variables,
    data: {
      jobSearchByQuery: {
        ...jobSearchByQuery,
        collection: updateCollection(jobSearchByQuery, jobId, bookmarked),
      },
    },
  });
};

const updateBookmarkStateOnCache = (bookmarked: boolean) =>
  bookmarked ? 'SAVED' : 'NOT_BOOKMARKED';

const checkBookmarkState = (state?: string) => state !== 'NOT_BOOKMARKED';

export { updateCache, checkBookmarkState };
